.line {
  display: flex;
  align-items: baseline;
  gap: 0.75rem;
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  color: var(--muted);
}

.stale {
  color: var(--warn);
}

.refresh {
  font-family: var(--font-mono);
  font-size: var(--text-min-mono);
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
}

.refresh:focus-visible {
  outline: 2px solid var(--cy-500);
  outline-offset: 2px;
}
